import React from 'react';
import { MegaphoneOff, Clock, Coins, LayoutGrid } from 'lucide-react';

export const Problem = () => (
    <section style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-primary)', position: 'relative' }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                    Does this sound <span style={{ color: 'var(--text-secondary)' }}>familiar?</span>
                </h2>
                <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                    Traditional service models are breaking under pressure, causing lost revenue and burned-out teams.
                </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px' }}>
                {[
                    { icon: MegaphoneOff, title: 'Guests waving hands for 10 minutes', desc: 'Trying to get attention across a busy floor.' },
                    { icon: Clock, title: 'Managers shouting across the floor', desc: 'Communicating orders and tables manually.' },
                    { icon: Coins, title: 'Bills taking forever', desc: 'Waiting too long just to pay and leave.' },
                    { icon: LayoutGrid, title: 'Staff denying responsibility', desc: '"That is not my table!" when guests need help.' },
                    { icon: MegaphoneOff, title: 'Customers leaving bad reviews', desc: 'Great food ruined by slow, unorganized service.' },
                ].map((item, idx) => {
                    const Icon = item.icon;
                    return (
                        <div key={idx} className="glass-panel" style={{ padding: '32px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div style={{ background: 'rgba(239, 68, 68, 0.1)', padding: '16px', borderRadius: '12px', width: 'fit-content' }}>
                                <Icon size={28} color="#EF4444" />
                            </div>
                            <h3 style={{ fontSize: '1.25rem', fontWeight: 600 }}>{item.title}</h3>
                            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>{item.desc}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);
